module.exports = __webpack_public_path__ + "static/media/16UNODC28.70881687.jpg";